import { useEffect, useMemo } from 'react';
import { GrowthBook } from '@growthbook/growthbook-react';
import titan from '@narvar/titan-client';
import { TitanAnalyticsOptions } from './useTitanAnalytics';

interface GrowthBookClientOptions extends TitanAnalyticsOptions {}

const useGrowthBookClient = ({
  sourceWriteKey,
  dataPlaneUrl,
}: GrowthBookClientOptions) => {
  const growthbook = useMemo(() => {
    const { GROWTHBOOK_CLIENT_KEY, GROWTHBOOK_DECRYPTION_KEY } =
      window.process.env;

    const titanAnalytics = titan({
      sourceWriteKey,
      url: dataPlaneUrl,
    });

    return new GrowthBook({
      apiHost: 'https://growthbook.narvarcp.com',
      clientKey: GROWTHBOOK_CLIENT_KEY,
      decryptionKey: GROWTHBOOK_DECRYPTION_KEY,
      enableDevMode: true,
      subscribeToChanges: false,
      backgroundSync: false,
      attributes: {
        userAgent: navigator.userAgent,
      },
      trackingCallback: (experiment, result) => {
        titanAnalytics
          ?.track({
            event: 'experiment_viewed',
            channel: 'web',
            type: 'track',
            context: {},
            properties: {
              experimentId: experiment.key,
              variationId: result.variationId.toString(),
              narvar_product_context: 'track',
            },
          })
          // eslint-disable-next-line no-console
          .catch((error) => console.error(error));
      },
      onFeatureUsage: (key) => {
        titanAnalytics
          ?.track({
            event: 'product_viewed',
            channel: 'web',
            type: 'track',
            context: {},
            properties: {
              experimentId: key,
              narvar_product_context: 'track',
            },
          })
          // eslint-disable-next-line no-console
          .catch((error) => console.error(error));
      },
    });
  }, [dataPlaneUrl, sourceWriteKey]);

  useEffect(() => {
    // Load features asynchronously when the app renders
    // eslint-disable-next-line no-console
    growthbook.loadFeatures().catch((error) => console.error(error));
  }, [growthbook]);

  return growthbook;
};

export default useGrowthBookClient;
